// src/Realty/pages/PersonalDataPage/index.tsx
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../store";
import {
    selectInstagram,
    selectTelegram,
    selectUserInfo,
    selectWhatsapp,
    selectUpdateProfilePending,
    selectUpdateProfileError,
    selectUpdateProfileErrorMessage,
    selectUpdateProfileSuccess,
    selectUpdateProfileFieldErrors, // 🆕 селектор полевых ошибок
} from "../../store/selectors";
import { PersonalDataHeader } from "./components/PersonalDataHeader";
import { PersonalDataForm } from "./components/PersonalDataForm";
import { PersonalDataSkeleton } from "./components/PersonalDataSkeleton";
import { UserActionCreator } from "../../store/userActions";

type SavePayload = {
    name?: string | null;
    phone?: string | number | null;
    telegram?: string | null;
    whatsapp?: string | null;
    instagram?: string | null;
    password?: string;
    password_current?: string;
};

const _PersonalDataPage = ({
                               userData,
                               getContacts,
                               updateProfile,
                               telegram,
                               whatsapp,
                               instagram,
                               saving,
                               saveError,
                               saveErrorMessage,
                               saveSuccess,
                               fieldErrors, // 🆕
                           }) => {
    useEffect(() => {
        if (userData) {
            getContacts();
        }
    }, [getContacts, userData]);

    if (!userData) {
        return <PersonalDataSkeleton />;
    }

    const handleSave = (payload: SavePayload) => {
        updateProfile(payload);
    };

    return (
        <div className="max-w-3xl mx-auto">
            <PersonalDataHeader name={userData.name} color={userData.avatarColor} />
            <PersonalDataForm
                user={userData}
                contacts={{ telegram, whatsapp, instagram }}
                onSave={handleSave}
                saving={saving}
                saveError={saveError}
                saveErrorMessage={saveErrorMessage}
                saveSuccess={saveSuccess}
                // 🆕 прокидываем полевые ошибки (например, phone)
                fieldErrors={fieldErrors}
            />
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    userData: selectUserInfo(state),
    telegram: selectTelegram(state),
    whatsapp: selectWhatsapp(state),
    instagram: selectInstagram(state),

    // состояние сохранения профиля
    saving: selectUpdateProfilePending(state),
    saveError: selectUpdateProfileError(state),
    saveErrorMessage: selectUpdateProfileErrorMessage(state),
    saveSuccess: selectUpdateProfileSuccess(state),
    fieldErrors: selectUpdateProfileFieldErrors(state), // 🆕 { [field]: string[] }
});

const mapDispatchToProps = {
    getContacts: UserActionCreator.getContacts,
    updateProfile: UserActionCreator.updateProfile,
};

export const PersonalDataPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(_PersonalDataPage);
